import { useQuery } from "@tanstack/react-query";
import { getPartiesRelatedPartiesExpiringDocuments } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

const EXPIRING_RELATED_PARTIES_QUERY_KEY = "EXPIRING_RELATED_PARTIES";

export const expiringRelatedPartiesKeys = {
  all: [EXPIRING_RELATED_PARTIES_QUERY_KEY],
};

export const useExpiringRelatedPartiesQuery = () =>
  useQuery({
    queryKey: expiringRelatedPartiesKeys.all,
    queryFn: processResponseWithApiProblemDetails(() =>
      getPartiesRelatedPartiesExpiringDocuments(),
    ),
    refetchOnWindowFocus: false,
  });
